import * as React from 'react';
import { About as AboutComponent } from '../../components/About';
import { about, IAboutTab } from '../../settings';
import { normalizeData, Typify } from '../../utils';
import { AboutTab } from '../AboutTab';

export function About() {
  const [activeTab, setActiveTab] = React.useState(about.tabs[0].id);
  const preparedTabs = React.useMemo(() => about.tabs.map(tab => ({ title: tab.title, value: tab.id })), []);
  const normalizedTabs = React.useMemo(() => normalizeData<Typify<IAboutTab>>(about.tabs), []);
  const currentTab = normalizedTabs.hash[activeTab];

  return (
    <AboutComponent
      title={about.title}
      sectionTabTitle={about.title}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      tabs={preparedTabs}
      tabContent={<AboutTab tab={currentTab} activeTab={activeTab} />}
    />
  );
}
